import { useMemo } from 'react';
import { Vault } from 'types';

import useGetDlVault from './useGetDlVault';

export interface UseGetVaultsOutput {
  isLoading: boolean;
  data: Vault[];
}

const useGetVaults = ({ accountAddress }: { accountAddress?: string }): UseGetVaultsOutput => {
  const { data: dlVault, isLoading: isDlVaultLoading } = useGetDlVault({
    accountAddress,
  });

  const data: Vault[] = useMemo(() => {
    const allVaults = [];
    if (dlVault) {
      allVaults.push(dlVault);
    }
    return allVaults;
  }, [JSON.stringify(dlVault)]);

  const isLoading = isDlVaultLoading;

  return {
    data,
    isLoading,
  };
};

export default useGetVaults;
